// Twitter Bootstrap modal
// import 'bootstrap/js/dist/modal';
import 'bootstrap';
var Cookies = require('js-cookie');

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Starter = {
		// All pages
		'common': {
			init: function() {

                const $menuwrapper = $('nav');
                $('.menubtn').on('click', function(){
                    $(this).toggleClass('is-active');
                    $menuwrapper.toggleClass('mobilemenu-active');
                    $('body').toggleClass("fixedPosition");
                });

                // Menu
                $('.menubtn').on('click', function () {
                    $('body').toggleClass('menu-active');
                });
                $('.closebtn').on('click', function () {
                    $('body').removeClass('menu-active');
                });

            }
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Starter;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

  	// Load Events
	$(document).ready(UTIL.loadEvents);


    var Flickity = require('flickity');
    var jQueryBridget = require('jquery-bridget');
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    var $blockShop = $('.block__shops');
    if ($blockShop.length) {
        var $carousel = $('.caroussel--shop').flickity({
            prevNextButtons: true,
            autoPlay: false,
            contain: true,
            draggable: true,
            freeScroll: true,
            pageDots: false,
            wrapAround: true,
            lazyLoad: 3,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 50,
                x3: 15
            }
        });
        var flkty = $carousel.data('flickity');
    }

    var $blockVacancy = $('.block__vacancies');
    if ($blockVacancy.length) {
        var $carousel = $('.caroussel--vacancy').flickity({
            prevNextButtons: true,
            autoPlay: false,
            contain: true,
            draggable: false,
            pageDots: false,
            freeScroll: true,
            wrapAround: true,
            lazyLoad: 3,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 50,
                x3: 15
            }
        });
        var flkty = $carousel.data('flickity');
    }

    var $productContainer = $('.block__caroussel ');

    if ($productContainer.length) {
        var $caroussel = $('.caroussel').flickity({
            cellSelector: '.caroussel__cell',
            prevNextButtons: true,
            contain: true,
            imagesLoaded: true,
            percentPosition: false,
            pageDots: false,
            draggable: false,
            freeScroll: true,
            wrapAround: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 50,
                x3: 15
            }
        });

        var flkty = $caroussel.data('flickity');
        var $caption = $('.caption');
        var $color = $('.color-wrapper');

        $caption.text(flkty.selectedElement.dataset.caption);
        $color.attr("class",flkty.selectedElement.dataset.color);

        $caroussel.on('select.flickity', function () {
            $caption.text(flkty.selectedElement.dataset.caption);
            $color.attr("class",flkty.selectedElement.dataset.color);
        });
    }

    var mixitup = require('mixitup');

    var $mixWrapper = $('.mixwrapper');
    if($mixWrapper.length > 0) {

        var mixer = mixitup($mixWrapper, {
            selectors: {
                target: '.mix'
            },
            animation: {
                duration: 400
            },
        });
    }

    if($('nav').hasClass('.mobilemenu-active')) {
        $('nav').addClass("fixedPosition");
    }
    else {
        $('body').removeClass("fixedPosition");
    }

    // Cookie warning
    var cookieWarning = Cookies.get('cookiewarning');
    if (cookieWarning != 'warned') {
        $(window).on('load', function() {
            setTimeout(function () {
                $('.cookie_warning').addClass('cookie_warning--visible');
            }, 1000);
        });
    }
    $(document).on('click', '.js-button--cookies', function (evt) {
        evt.preventDefault();
        $('.cookie_warning').removeClass('cookie_warning--visible');
        Cookies.set('cookiewarning', 'warned', { expires: 7 });
    });



    var $newsletterModal = $('.block__newsletter--1');
    if($newsletterModal.length>0) {
        var newsletterModal = Cookies.get('newslettermodal');
        if (newsletterModal != 'shown') {
            setTimeout(function() {
                $newsletterModal.addClass('block__newsletter--1--visible');
                Cookies.set('newslettermodal', 'shown');
            }, 5000);
        }
    }

    $(document).on('click', '.closemodalbutton', function() {
        $('.block__newsletter--1--visible').removeClass('block__newsletter--1--visible');
    });

    $(document).on('click', '.block__newsletter--1--visible', function(evt) {
        evt.preventDefault();
        $('.block__newsletter--1--visible').removeClass('block__newsletter--1--visible');
    }).on('click', '.block__halfwidth__textonly', function (evt) {
        evt.stopPropagation();
    });


})(jQuery);
